export default __webpack_public_path__ + "static/media/4_template.06104699.svg";